import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import DwhReportManagementBlockData from 'Models/Content/DwhReportManagementBlockData';
import MainDwhReportManagement from './MainDwhReportManagement';

export default class DwhReportManagementBlock extends EpiComponent<DwhReportManagementBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainDwhReportManagement iContent={this.props.data} context={this.getContext()} />;
  }
}
// The file appears to be correct and does not require any changes or fixes at this time.


